// extracted by mini-css-extract-plugin
module.exports = {"c_black":"#424242","c_red":"#FF615C","c_grey_mid":"#4A6173"};